import * as THREE from "three";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import { FBXLoader } from "three/examples/jsm/loaders/FBXLoader";

// NOTE:
// load로 읽을때와 parse로 읽을때의 경로설정이 달라진다.

export default class AppModel {
  // support gltf and glb file
  static async load(gltfUrl) {
    return new Promise((resolve, reject) => {
      new GLTFLoader().load(gltfUrl, (gltf) => {
        try {
          return resolve(new AppModel(gltf));
        } catch (error) {
          reject(error);
        }
      });
    });
  }

  static async loadFBX(fbxUrl) {
    return new Promise((resolve, reject) => {
      new FBXLoader().load(fbxUrl, (fbx) => {
        try {
          return resolve(new AppModel(fbx));
        } catch (error) {
          reject(error);
        }
      });
    });
  }

  /**
   * @param {*} gltf
   * @returns {Promise<AppModel>}
   */
  static async parse(gltf /* raw, string, json*/) {
    return new Promise((resolve, reject) => {
      try {
        new GLTFLoader().parse(gltf, "", (_gltf) => {
          resolve(new AppModel(_gltf));
        });
      } catch (error) {
        reject(error);
      }
    });
  }

  constructor(gltf) {
    this._gltf = gltf;
    this._scene = gltf.scene;
    // Three.AnimationClip[]
    this._animations = (gltf.animations || []).map((clip) => {
      // Blender에서 변경하기 힘들어서 여기서 변경하지 idle은 sleep이다
      // if (name === "idle") name = "sleep";
      if (clip.name === "idle") clip.name = "sleep";
      return clip;
    });

    this._mixer = new THREE.AnimationMixer(this._scene);
  }

  get gltf() {
    return this._gltf;
  }

  /**
   * @return {THREE.Scene}
   */
  get scene() {
    return this._scene;
  }

  /**
   * @return {THREE.AnimationMixer}
   */
  get mixer() {
    return this._mixer;
  }

  /**
   *  @return {THREE.AnimationClip[]}
   */
  get animations() {
    return this._animations;
  }
}
